export default "https://c.travel-assets.com/partner-portal/skewed_box.7ef0dde6bb86.svg";